
export const ERRORS = {
    // 932: 'El proceso de registro de prueba de vida se realizó correctamente.',
    // 1001: 'El usuario que se quiere loguear no existe.',
    // 1002: 'El login se realizó con éxito.',
    // 1003: 'El login fue rechazado por falta de información.',
    // 1004: 'Se está intentando registrar un usuario ya existente, y no está permitido por configuración.',
    // 1005: 'Se realizó el login con un username, y dicho usuario no tiene almacenada una SN.',
    // 1006: 'Falló la registración del nuevo usuario de Face (con biometría de gobierno activada).',
    // 1007: 'El formato del countryCode al hacer el login es erróneo (deben ser 2 caracteres numéricos).',
    // 1008: 'El countryCode no es admitido.',
    // 1009: 'Se intenta hacer un login con la API Key de un país y el countryCode que se está enviando corresponde a otro.',
    // 1010: 'No se envió el countryCode.',
    // 1011: 'El registro del usuario falló. Se detectó a través del identify() que el usuario que se quiere registrar ya existe.',
    // 1014: 'La API Key que se envió no es válida.',
    // 1015: 'No se envió header de API Key pública (x-access-apikey) ni privada (x-access-apikey-private).',
    // 1016: 'Se envió API Key pública (x-access-apikey) y privada (x-access-apikey-private).',
    // 1017: 'La API Key privada no es válida.',
    // 1018: 'La API Key pública está dando acceso a un endpoint privado.',
    // 2001: 'No se detectó rostro en la selfie.',
    // 2004: 'El rostro no pudo ser detectado por el motor de biometría de Microsoft.',
    // 2006: 'El request al endpoint para biometría gubernamental falló (no está disponible).',
    // 2009: 'El usuario de Face que se está intentando eliminar o desbloquear no existe.',
    // 2010: 'El usuario de Face fue bloqueado por haber superado la cantidad de login configurada por negocio.',
    // 2011: 'El usuario de Face fue dado de baja correctamente.',
    // 2012: 'El usuario de Face fue desbloqueado correctamente.',
    // 2013: 'El usuario que se intenta desbloquear no se encuentra bloqueado.',
    // 2015: 'No se superó la validación de la selfie neutral (SN) enviada contra la SN ya registrada, debido a que los rostros no se parecen.',
    // 2016: 'No se superó la validación de la selfie neutral (SN) enviada contra la SN ya registrada, debido a un error.',
    // 2017: 'No se obtuvo información del login debido a un error en base de datos.',
    // 2018: 'No se obtuvo información del login debido a que no se realizó ningún login.',
    // 2019: 'La información del login se obtuvo correctamente.',
    // 2020: 'Se requiere enviar el faceLoginGuid en el request.',
    // 2023: 'La selfie no supera la validación de "Fondo".',
    // 2025: 'La selfie no supera la validación de "Balance monocromático".',
    // 2027: 'La selfie no supera la "Validación cruzada de fondos".',
    // 2028: 'La selfie no supera la validación de "Tramas de pantalla".',
    // 2029: 'La selfie no supera la validación de "Barrido de pantalla".',
    // 2030: 'La selfie no supera la validación de "Flash".',
    // 2031: 'La selfie no supera la validación de "Líneas".',
    // 2032: 'La selfie no supera la validación de "Machine Learning antispoofing".',
    // 2033: 'La selfie no supera la validación de "Tamaño selfies".',
    // 2034: 'La selfie no supera la validación de "Tamaño rostros".',
    // 2035: 'La selfie no supera la "Validación anteojos".',
    // 2036: 'La identificación del rostro falló.',
    // 2037: 'La identificación del rostro se realizó con éxito.',
    // 3002: 'El proceso de registro de prueba de vida falló.',
    // 3011: 'Falló la registración del nuevo usuario.',
    // 11100: 'La configuración se obtuvo correctamente.',
    // 11101: 'La configuración no se obtuvo.',
    // 11110: 'La biometría del ciudadano se obtuvo correctamente.',
    // 11111: 'La biometría del ciudadano no se obtuvo.',
    // 11120: 'La información del ciudadano se obtuvo correctamente.',
    // 11121: 'La información del ciudadano no se obtuvo.',
    // 11130: 'La configuración de servicio del cliente se obtuvo correctamente.',
    // 11131: 'La configuración de servicio del cliente no se obtuvo.',
    // 11132: 'La configuración histórica paginada de servicio del cliente se obtuvo correctamente.',
    // 11133: 'La configuración histórica paginada de servicio del cliente no se obtuvo.',
    // 11140: 'Los datos de servicio del cliente fueron actualizados correctamente.',
    // 11141: 'Los datos de servicio del cliente no fueron actualizados.',
    // 11150: 'La configuración de servicio del cliente fue creada correctamente.',
    // 11151: 'La configuración de servicio del cliente no fue creada.',
    // 11152: 'La configuración de servicio del cliente por cliente, fue creada correctamente.',
    // 11153: 'La configuración de servicio del cliente por cliente, falló.',
    64052001: 'No se superó la validación de gesto sonrisa (SS).',
    64052002: 'No se superó la validación de gesto ojos cerrados (SCE).',
    64052003: 'No se superó la validación de gesto guiño izquierdo (SBL).',
    64052004: 'No se superó la validación de gesto guiño derecho (SBR).',
    64052005: 'Por favor, colocar la cámara a la altura de los ojos para tomar la foto.'
}

export default ERRORS;